import { apiRequest } from '@/utils/request'
import axios from 'axios'
import { withLangParams, getApiLangType } from '@/utils/langApi'

const UPLOAD_BASE = 'http://localhost:8088'

function cmsList(url, query, locale) {
  return apiRequest({ url, method: 'get', params: withLangParams(query || {}, locale) })
}

export function listIndexManager(query, locale) {
  return cmsList('/system/indexManager/list', query, locale)
}

export function listModelManager(query, locale) {
  return cmsList('/system/modelManager/list', query, locale)
}

export function listContactInfo(query, locale) {
  return cmsList('/system/contactInfo/list', query, locale)
}

export function listCompanyInfo(query, locale) {
  return cmsList('/system/companyInfo/list', query, locale)
}

export function listNews(query, locale) {
  return cmsList('/system/news/list', query, locale)
}

export function getNews(id) {
  return apiRequest({ url: '/system/news/' + id, method: 'get' })
}

export function listProduct(query, locale) {
  return cmsList('/system/product/list', query, locale)
}

export function getProduct(id) {
  return apiRequest({ url: '/system/product/' + id, method: 'get' })
}

export function listProductCategory(query, locale) {
  return cmsList('/system/productCategory/list', query, locale)
}

export function listNewsCategory(query, locale) {
  return cmsList('/system/newsCategory/list', query, locale)
}

export function listSiteNavItem(query, locale) {
  return cmsList('/system/siteNavItem/list', query, locale)
}

export function listSolutionCategory(query, locale) {
  return cmsList('/system/solutionCategory/list', query, locale)
}

export function listSolutionItem(query, locale) {
  return cmsList('/system/solutionItem/list', query, locale)
}

export function getSolutionItem(id) {
  return apiRequest({ url: '/system/solutionItem/' + id, method: 'get' })
}

/** Resolve OSS video into an inline-playable signed URL */
export function getMediaPlayUrl(url) {
  return apiRequest({ url: '/common/mediaPlay', method: 'get', params: { url } })
}

export function listSiteStat(query, locale) {
  return cmsList('/system/siteStat/list', query, locale)
}

export function listCertificate(query, locale) {
  return cmsList('/system/certificate/list', query, locale)
}

export function listServiceItem(query, locale) {
  return cmsList('/system/serviceItem/list', query, locale)
}

export function listFriendLink(query, locale) {
  return cmsList('/system/friendLink/list', query, locale)
}

export function submitContactMessage(data) {
  return apiRequest({ url: '/system/contactMessage', method: 'post', data })
}

export function uploadContactFile(file, onProgress) {
  const formData = new FormData()
  formData.append('file', file)
  return axios({
    url: UPLOAD_BASE + '/common/upload',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000,
    onUploadProgress: onProgress
  }).then(res => res.data)
}
